import { PLATFORM_NAME } from 'shared/constants';
import { Helmet } from 'react-helmet-async';

interface Props {
  title?: string
}

const PageTitle: React.FC<Props> = (
  { title }: Props,
) => (
  <Helmet>
    <title>
      {title ? `${PLATFORM_NAME} | ${title}` : PLATFORM_NAME}
    </title>
  </Helmet>
);

export default PageTitle;
